import { memo } from 'react';
import { Box, useTheme, Typography, useMediaQuery } from '@mui/material';
import { Dialog, Icon, Button } from 'bs-unified-ui';

const DialogSave = ({
  open,
  isLoading,
  handleCancel,
  handleSubmit,
  isDisabled = false,
}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down(1024));

  return (
    <Dialog
      open={open}
      maxWidth='min(1184px, 80vw)'
      placement='bottom'
      bgColorContent={theme.foreground.black}
      hideBackdrop
      disableEnforceFocus
      style={{ position: 'initial' }}
      disableBackdropClick
      disableAutoFocus
      sx={{
        ...(isTablet ? {} : { marginLeft: 32 }),
        '& .MuiPaper-root': {
          m: 2,
          zIndex: 10,
        },
        '& .MuiDialogContent-root': {
          paddingLeft: 3,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        data-testid='dialog-save'
      >
        <Box>
          <Icon
            name='save'
            type='fill'
            isCustom={false}
            size={16}
            color={theme.foreground.white}
          />
          <Typography
            variant='fs16'
            sx={{ ml: 1 }}
            color={theme.foreground.white}
          >
            Changes
          </Typography>
        </Box>
        <Box>
          <Button
            onClick={handleSubmit}
            disabled={isLoading || isDisabled}
            loading={isLoading}
          >
            Save
          </Button>
          <Button
            sx={{
              'ml': 2,
              'bgcolor': 'transparent',
              '&:hover': {
                bgcolor: '#ffffff1a',
              },
            }}
            onClick={handleCancel}
            disabled={isLoading}
          >
            Discard
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default memo(DialogSave);
